import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { ToastrService } from 'ngx-toastr';
import { ScorePopupComponent } from '../../shared/popups/score-popup/score-popup.component';
import { ApiCallsService } from '../../shared/services/network/api-calls.service';
import { api } from '../../utils/endpoints';
import { fileDirectories } from '../../utils/view-settings';

import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CommentBoxComponent } from '../../shared/popups/comment-box/comment-box.component';
import { LikesListComponent } from '../../shared/popups/likes-list/likes-list.component';
import { AppSyncService } from '../../shared/services/appsync/appsync.service';
import { CommonDataSharingService } from '../../shared/services/common-data-sharing.service';
import { UserService } from '../../shared/services/user.service';
import { SafeHtmlPipe } from '../../shared/validators/safe-html.pipe';
import { DATE_FORMAT } from '../../utils/constants';
import { ICONS } from '../../utils/svg-icons';
@Component({
  selector: 'app-details-feed',
  imports: [CarouselModule, CommonModule, CommentBoxComponent, SafeHtmlPipe],
  templateUrl: './details-feed.component.html',
  styleUrl: './details-feed.component.scss',
})
export class DetailsFeedComponent implements AfterViewInit {
  DATE_FORMAT = DATE_FORMAT;
  isInitialized = false;
  customOptions: OwlOptions = {
    loop: false,
    autoplay: false,
    center: false,
    dots: true,
    nav: true,
    navText: [
      '<img src="assets/images/ic_arrow_left.svg" class="arrow__icon" alt="Previous" />',
      '<img src="assets/images/ic_arrow_left.svg" class="arrow__icon right" alt="Next" />',
    ],
    autoHeight: false,
    autoWidth: true,
    responsive: {
      0: {
        items: 1,
      },
    },
  };
  fileDirectoriesPath: any = fileDirectories.profile;
  activeScore = false;
  @Input() public itemsList: any;
  @Input() public data: any;
  @Input() query: any;
  sectionHideForPublicFeed: boolean = false;
  reload = false;
  likeFeed = false;

  private appsyncEndpoint = (environment as any).appsyncEndpoint;
  private apiKey = (environment as any).apiKey;
  commentCount: any;
  likeCount: any;
  private subscription: Subscription | undefined;
  private subscribeToLike: Subscription | undefined;
  userDetail: any;
  ICONS = ICONS;

  constructor(
    private cdr: ChangeDetectorRef,
    private _toast: ToastrService,
    private _apiService: ApiCallsService,
    private _ngbModal: NgbModal,
    private _activeModal: NgbActiveModal,
    private _appSyncService: AppSyncService,
    private _commonDataService: CommonDataSharingService,
    private _userService: UserService,
    private _router: Router,
  ) {}
  ngOnInit() {
    if (this.query.anotherKey == 'publicFeed') {
      this.sectionHideForPublicFeed = true;
    }
    this._userService.user.subscribe((user: any) => {
      this.userDetail = user ?? null;
    });
    this.attachSubscription();
  }
  ngAfterViewInit() {
    this.postCount();
    setTimeout(() => {
      this.isInitialized = true;
      this.cdr.detectChanges(); // Trigger re-render
    }, 100);
  }
  onClose(): void {
    this._activeModal.close(this.reload);
  }
  openScoreUserPopup(): void {
    this.activeScore = true;
    const addEditUserPopup = this._ngbModal.open(ScorePopupComponent, {
      size: 'lg',
      centered: true,
      scrollable: false,
      backdrop: 'static',
      keyboard: false,
    });
    addEditUserPopup.componentInstance.filtersList = this.data;
    addEditUserPopup.result.then((result: any) => {
      this.activeScore = false;
      if (result) {
        this._apiService.patch(api._FeedPost + '/' + this.data.id + '/assign-score', result).subscribe({
          next: (res: any) => {
            this._toast.success('Updated successfully');
            this.data.canBeScored = false;
            this.reload = true;
            this.data.averageExpertScores = res.data.averageExpertScores;
          },
          error: (error: any) => {
            console.log(error);
          },
        });
      }
    });
  }
  openLikeList(data: any) {
    let modalRef = this._ngbModal.open(LikesListComponent, { scrollable: false, backdrop: 'static', keyboard: false, size: 'filterPopup' });
    modalRef.componentInstance.postId = data.id;
  }
  postCount() {
    let array: any = [this.data.id];
    const mutation = `query getPostsCounts {
        getPostsCounts(postIds: ${JSON.stringify(array)},currentUserId:\"${this.userDetail?.id}\") {
            items {
            commentCount
            isCurrentUserLiked
            likeCount
            postId
          }
        }
      }`;
    return fetch(this.appsyncEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': this.apiKey,
      },
      body: JSON.stringify({ query: mutation }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          throw new Error(JSON.stringify(data.errors));
        }
        this.likeFeed = data.data.getPostsCounts?.items[0]?.isCurrentUserLiked;
        this.commentCount = data.data.getPostsCounts?.items[0]?.commentCount;
        this.likeCount = data.data.getPostsCounts?.items[0]?.likeCount;
        return data;
      })
      .catch((error) => {
        console.error('Error adding comment:', error);
        throw error;
      });
  }
  attachSubscription() {
    this.subscription = this._appSyncService.subscribeToComments('', this.userDetail?.id).subscribe({
      next: (data) => {
        if (data?.data?.commentSubscription?.comment?.postId == this.data.id) {
          this.likeCount = data?.data?.commentSubscription?.postCounts?.likeCount;
          this.commentCount = data?.data?.commentSubscription?.postCounts?.commentCount;
        }
        // });
      },
    });
    this.subscribeToLike = this._appSyncService.subscribeToLike('', this.userDetail?.id).subscribe({
      next: (data) => {
        if (data?.data?.likeSubscription?.postCounts?.postId == this.data.id) {
          if (data?.data?.likeSubscription?.postCounts?.isCurrentUserLiked) {
            this.likeFeed = data?.data?.likeSubscription?.postCounts?.isCurrentUserLiked;
          }
          this.likeCount = data?.data?.likeSubscription?.postCounts?.likeCount;
        }
      },
    });
  }
  likeFeeds(postid: any, userId: any) {
    if (!this.likeFeed) {
      this.likeFeed = true;
      this._commonDataService.likeFeed(postid, userId);
    } else {
      this.likeFeed = false;
      this._commonDataService.unlikeFeed(postid, userId);
    }
  }
  userSearch(data: any) {
    this._activeModal.close(this.reload);
    this._router.navigate(['/user/feed/' + data?.id]);
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.subscribeToLike?.unsubscribe();
  }
}
